const { CountryOfOperationItems, countryShouldAcceptInteger } = require('../utils/constants');

/* eslint-disable indent */
const getFrontSnippetPlaceholder = (formData, defaultInitializationOptions, finalPaymentMethods, i18n) => {
const unitPriceShouldAcceptInteger = countryShouldAcceptInteger(formData.publicKey);

  return (`
  <html>
  <head>
    <script src="https://sdk.mercadopago.com/js/v2"></script>
  </head>
  <body>
    <div id="cardPaymentBrick_container"></div>
    <script>
      const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
        locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
      });
      const bricksBuilder = mp.bricks();
      const renderCardPaymentBrick = async (bricksBuilder) => {
        const settings = {
          initialization: {
            amount: 10000, // ${unitPriceShouldAcceptInteger ? i18n.gettext('monto a ser pago') : i18n.gettext('monto a ser pago. Debe ser un número entero.')}
              : i18n.gettext('monto a ser pago')}
            payer: {
              email: "${defaultInitializationOptions.email}",
            },
          },
          customization: {
            visual: {
              ${!formData.showTitle ? 'hideFormTitle: true,' : ''}
              ${!formData.showPaymentButton ? 'hidePaymentButton: true,' : ''}
              style: {
                theme: ${
                  `'${formData.theme}'` || 'default'
                }, // | 'dark' | 'bootstrap' | 'flat'
              }
            },
            ${
              formData.paymentMethod.length < 2
                ? `
              paymentMethods: {
                types: {
                  excluded: [${finalPaymentMethods.map((item) => `'${item}'`)}]
                },
                ${
                  formData.maxInstallments
                    ? `maxInstallments: ${formData.maxInstallments},`
                    : ''
                }
              }
            `
                : ''
            }
          },
          callbacks: {
            onReady: () => {
              // ${i18n.gettext('callback llamado cuando Brick esté listo')}
            },
            onSubmit: (cardFormData) => {
              //  ${i18n.gettext('callback llamado cuando el usuario haga clic en el botón enviar los datos')}
              //  ${i18n.gettext('ejemplo de envío de los datos recolectados por el Brick a su servidor')}
              return new Promise((resolve, reject) => {
                fetch("/process_payment", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(cardFormData)
                })
                  .then((response) => {
                    // ${i18n.gettext('recibir el resultado del pago')}
                    resolve();
                  })
                  .catch((error) => {
                    // ${i18n.gettext('tratar respuesta de error al intentar crear el pago')}
                    reject();
                  })
              });
            },
            onError: (error) => {
              // ${i18n.gettext('callback llamado para todos los casos de error de Brick')}
            },
          },
        };
        window.cardPaymentBrickController = await bricksBuilder.create('cardPayment', 'cardPaymentBrick_container', settings);
      };
      renderCardPaymentBrick(bricksBuilder);
    </script>
  </body>
  </html>
  `);
};

module.exports = { getFrontSnippetPlaceholder };
